import './bootstrap'

import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import Vuex from 'vuex'
/* import VueInputMask from 'vue-inputmask'; */

import vSelect from 'vue-select'

import VueToastr from '@deveodk/vue-toastr'
import ToggleButton from 'vue-js-toggle-button'
import VueInputMask from 'vue-inputmask'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

import {
  VueTables, ServerTable, ClientTable, Event,
} from 'vue-tables-2'

import '../node_modules/@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import './assets/css/main.css'
import './assets/css/camera-mirror.css'
import './assets/auxiliary/fontawesome/css/all.min.css'
import 'vue-select/dist/vue-select.css'
import '../node_modules/moment/moment'

import VueLoading from 'vuejs-loading-plugin'

import swal from 'sweetalert'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

import * as VueGoogleMaps from 'vue2-google-maps'
import { errorBodyToHtml } from './utils/apiError'
import App from './App.vue'
import mainStore from './store'
import store from './store'
import router from './router'

window.axios = axios
Vue.prototype.$http = window.axios
// using default options

// overwrite defaults
Vue.use(VueLoading, {
  dark: false, // default false
  text: '', // default 'Loading'
  loading: false, // default false
  background: 'rgb(255,255,255, 0.68)', // set custom background
  classes: ['loadingOverwrite'], // array, object or string
})

window.moment = require('moment')

moment.locale('pt-br')

const translation = {
  count: 'Mostrando {from} de {to} até {count} de registros',
  filter: 'Pesquisar:',
  filterPlaceholder: 'Pesquisar',
  limit: 'Registros:',
  noResults: 'Nenhum registro encontrado',
  page: 'Página:',
  filterBy: 'Filtrar por {column}',
  // for dropdown pagination filterBy: 'Filter by {column}',
  // Placeholder for search fields when filtering by column loading:'Loading...',
  // First request to server defaultOption:'Select {column}'
  // default option for list filters }
}

const options = {
  requestFunction(data) {
    // data.token = this.$store.getters.token
    return axios
      .get(this.url, {
        params: data,
      })
      .catch(
        e => {
          this.dispatch('error', e)
          router.push('/login')
        },
      )
  },
  texts: translation,
  pagination: { chunk: 15, dropdown: false, nav: 'scroll' },
  perPage: 10,
  perPageValues: [10, 25, 50, 100],
}

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(ServerTable, options, false, 'bootstrap4', 'footerPagination')

Vue.use(VueToastr)
Vue.use(ToggleButton)

Vue.component('date-time', VueCtkDateTimePicker)

Vue.use(VueInputMask.default)
/*
Vue.use(VueInputMask) */
/* Vue.use(VueInputMask) */
// Composition API
Vue.use(VueCompositionAPI)
Vue.component('v-select', vSelect)

Vue.use(Vuex)

// import core styles
require('@core/scss/core.scss')
require('@core/scss/base/pages/app-chat-list.scss')
require('@core/scss/base/pages/app-chat.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

// export const store = new Vuex.Store(mainStore);

new Vue({
  router,
  store,
  created() {
    this.$store.dispatch('initialize')
  },
  render: h => h(App),
}).$mount('#app')

Vue.prototype.$message = function (title, msg, type, url, timeout) {
  if (!timeout) {
    timeout = 4000
  }

  const newMsg = errorBodyToHtml(msg)

  this.$toastr('add', {
    title,
    msg: newMsg,
    clickClose: true,
    timeout,
    position: 'toast-top-right',
    type,
    onClicked: () => { this.$router.push(url) },

  })
}

Vue.prototype.$error = function (error) {
  const body = error && error.response ? error.response.data : error

  this.$message(null, errorBodyToHtml(body), 'error')
}
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBni4q53Pz1X6zwWqQznhNRg2-79ajar6E',
    libraries: '', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    /// / If you want to set the version, you can do so:
    // v: '3.26',
  },

  /// / If you intend to programmatically custom event listener code
  /// / (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  /// / instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  /// / you might need to turn this on.
  // autobindAllEvents: false,

  /// / If you want to manually install components, e.g.
  /// / import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  /// / Vue.component('GmapMarker', GmapMarker)
  /// / then disable the following:
  // installComponents: true,
})
